module.exports = __webpack_public_path__ + "static/media/paso 3.92a52323.png";